import {
  MenuContent,
  MenuItem,
  MenuRoot,
  MenuTrigger,
} from '@/components/ui/menu';
import {
  FaCog,
  FaDatabase,
  FaMoneyBill,
  FaShieldAlt,
  FaWallet,
} from 'react-icons/fa';
import { IconButton } from '@chakra-ui/react';
import { Link } from '@/i18n/routing';
import { ImExit } from 'react-icons/im';
import { UserIcon } from '../ui/svgs/navIcons';
import { useTranslations } from 'next-intl';
import nProgress from 'nprogress';

interface UserHomeMenuProps {
  onDisconnect: () => void;
}

export function UserHomeMenu({ onDisconnect }: UserHomeMenuProps) {
  const t = useTranslations('Settings.Layout');

  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <IconButton
          aria-label="User home"
          variant="ghost"
          size="sm"
          color="text.t2"
          _hover={{
            bg: 'bg.t1',
          }}
        >
          <UserIcon />
        </IconButton>
      </MenuTrigger>

      <MenuContent
        width={200}
        padding={2}
        gap={4}
        borderRadius="12px"
        bg="bg.t1"
        backdropFilter="blur(20px)"
      >
        <Link href="/settings/my-assets" onClick={() => nProgress.start()}>
          <MenuItem
            height={11}
            p={3}
            value="copy"
            style={{ cursor: 'pointer' }}
          >
            <FaDatabase />
            {t('myAssets')}
          </MenuItem>
        </Link>
        <Link
          href="/settings/transaction-configuration"
          onClick={() => nProgress.start()}
        >
          <MenuItem
            height={11}
            p={3}
            value="transactionConfiguration"
            style={{ cursor: 'pointer' }}
          >
            <FaCog />
            {t('transactionConfiguration')}
          </MenuItem>
        </Link>
        <Link
          href="/settings/wallet-management"
          onClick={() => nProgress.start()}
        >
          <MenuItem
            height={11}
            p={3}
            value="walletSettings"
            style={{ cursor: 'pointer' }}
          >
            <FaWallet />
            {t('walletManagement')}
          </MenuItem>
        </Link>
        <Link href="/settings/my-commission" onClick={() => nProgress.start()}>
          <MenuItem
            height={11}
            p={3}
            value="myCommission"
            style={{ cursor: 'pointer' }}
          >
            <FaMoneyBill />
            {t('myCommission')}
          </MenuItem>
        </Link>
        <Link
          href="/settings/security-center"
          onClick={() => nProgress.start()}
        >
          <MenuItem
            height={11}
            p={3}
            value="securityCenter"
            style={{ cursor: 'pointer' }}
          >
            <FaShieldAlt />
            {t('securityCenter')}
          </MenuItem>
        </Link>
        <MenuItem
          height={11}
          p={3}
          value="disconnect"
          onClick={onDisconnect}
          style={{ cursor: 'pointer' }}
        >
          <ImExit />
          {t('logout')}
        </MenuItem>
      </MenuContent>
    </MenuRoot>
  );
}
